<template>
  <div class="pay_result_container">
    <div v-show="pathResultType == 'success' || pathResultType == 'success2'">
      <van-icon name="checked" class="success_icon" />
      <div class="result_text">
        支付成功
      </div>
      <div class="pay_money">{{ payMsg }}</div>
    </div>
    <div v-show="pathResultType == 'fail' || pathResultType == 'fail2'">
      <van-icon name="warning" class="fail_icon" />

      <div class="result_text">
        支付失败
      </div>
      <div class="pay_money">{{ payMsg }}</div>
    </div>
    <!-- 成功 -->
    <van-button
      v-show="pathResultType == 'success' || pathResultType == 'success2'"
      round
      type="info"
      size="normal"
      color="#F93244"
      class="btn"
      @click="openPage('/')"
      >返回首页</van-button
    >
    <!-- 订单 -->
    <van-button
      v-show="pathResultType == 'success'"
      round
      plain
      type="primary"
      size="normal"
      color="#F93244"
      class="btn"
      @click="openPage('/order')"
      >查看订单</van-button
    >
    <!-- 分站 -->
    <van-button
      v-show="pathResultType == 'success2'"
      round
      plain
      type="primary"
      size="normal"
      color="#F93244"
      class="btn"
      @click="openPage('/balance')"
      >查看订单</van-button
    >
    <!-- 失败 -->

    <van-button
      v-show="pathResultType == 'fail2'"
      round
      type="info"
      size="normal"
      color="#F93244"
      class="btn"
      @click="openPage('/rechrage')"
      >余额充值</van-button
    >

    <van-button
      v-show="pathResultType == 'fail' || pathResultType == 'fail2'"
      round
      plain
      type="primary"
      size="normal"
      color="#F93244"
      class="btn"
      @click="openPage('/order')"
      >返回首页</van-button
    >
    <div v-show="pathResultType == 'fail'" @click="openConcat">联系客服</div>
  </div>
</template>

<script>
import Vue from 'vue';
export default {
  data() {
    return {
      payResult: {}
    };
  },
  created() {
    this.payResult = Vue.ls.get('payResult');
    this.payMsg = this.payResult.msg;
    this.pathResultType = this.payResult.type;
  },
  beforeDestroy() {
    Vue.ls.remove('goodInfo');
    Vue.ls.remove('orderParams');
    Vue.ls.remove('totalPrice');
    Vue.ls.remove('addressList');
    Vue.ls.remove('payResult');
  },
  methods: {
    openPage(path) {
      this.$router.push( path);
    },
    openConcat() {
      window.open(
        'https://yzf.qq.com/xv/web/static/chat/index.html?sign=37ef9b97817c5390744c9abd4ae0e0344549e2a29e6fdc2fdf2b2137a1eaebae5c0f1ad81b0ab6a09db04a4b9520996e25ff7c'
      );
    }
  }
};
</script>

<style lang="less" scoped>
.pay_result_container {
  padding: 17.067vw 4.267vw;
  text-align: center;
}
.success_icon {
  font-size: 17.067vw;
  color: #f93244;
  margin-bottom: 8.533vw;
}
.fail_icon {
  font-size: 17.067vw;
  color: #bfbfbf;
  margin-bottom: 8.533vw;
}
.result_text {
  font-size: 5.333vw;

  color: #323233;
  margin-bottom: 4.267vw;
}
.pay_money {
  font-size: 3.733vw;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 30vw;
}
.btn {
  width: 91.467vw;
  height: 11.733vw;
  margin-bottom: 5.333vw;
}
</style>
